import React, { useEffect, useRef, useState } from "react";
import { Link, Redirect, useParams, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/gl";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "@react-keycloak/web";
import ShareIcon from "@material-ui/icons/Share";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
  URL_HOME,
  URL_LOGIN,
  URL_PRODUCTS,
} from "../../../../app/src/Components/Routes/Location";
import AlertNotification from "../../../../app/src/Components/GUI/Alert/Alert";
import Comments from "./Comments";
import Casting from "./Casting";
import Playlist from "./Playlist";
import Favorite from "./Favorite";
import Rating from "./Rating";
import VideoTag from "./VideoTag";
import VideoType from "./VideoType";
import "./VideoDetailPage.css";
import "./DetailPage.css";
import "./ReportContent.css";
import {
  DETAIL_TYPE_CONTAINER,
  REDIRECT_TO_LOGIN,
  REDIRECT_TO_PRODUCTS,
  SHOW_AGE_RESTRICTION_MODAL,
} from "./VideoDetailPageConstants";
import {
  saveContentActionCreator,
  saveContentHashActionCreator,
  saveContentPermissionsActionCreator,
  saveContentTypeActionCreator, saveProductsActionCreator,
  saveUserDataActionCreator,
  turnOffLoadingActionCreator,
  turnOnLoadingActionCreator,
} from "../../../../app/src/actions/commonActions";
import ReportContentModalComponent from "./ReportContentModalComponent";
import ShareContentModalComponent from "./ShareContentModalComponent";
import ExpiredSessionModalComponent from "../../../../app/src/Components/common/ExpiredSessionModalComponent";
import {
  URL_VIDEODETAIL,
} from "../../../../app/src/Components/Routes/Location";
import {
  LOCAL_STORAGE_KEY__LOCALE,
  VIDEO_TYPE_LIVE,
  VIDEO_TYPE_LIVE_TIIVII,
  VIDEO_TYPE_TIIVII_LIVE,
  VIDEO_TYPE_EXTERNAL_LIVE,
  VIDEO_TYPE_EXTERNAL_IFRAME,
  WIDGET_ACTION_DETAIL, WIDGET_TYPE_BANNER,
  AGE_RESTRICTION_18_PLUS,
  AGE_RESTRICTION_16_PLUS,
  AGE_RESTRICTION_12_PLUS,
  AGE_RESTRICTION_7_PLUS
} from "../../../../app/src/Utils/Constants";
import ErrorMessageModalComponent from "../../../../app/src/Components/common/ErrorMessageModalComponent";
import AgeRestrictionModalComponent from "../../../../app/src/Components/common/AgeRestrictionModalComponent";
import {
  TENANT,
  TENANT_PETISGO,
  MULTITENANT_CONSTANTS,
} from "../../../../app/src/Resources/Multitenant/tenantConstants";
import CalendarButtonComponent from "./CalendarButtonComponent";
import {
  getProductsDashboardService,
  getUserDataService,
  logUserAnalyticService,
  getAnonContentsService,
  getRelatedContentsService,
  getSerialContentsService,
  getContentPermissions,
  getContentsService,
  getUserFavorites,
  getCommentsService,
  reportContentService,
} from "../../../../app/src/services/services";
import {
  DETAIL_VALUE,
  PAGE_ID_KEY,
  PAGE_VIEW_ACTION,
  SELECT_ITEM_ACTION,
} from "../../../../app/src/analyticsConstants/analyticsConstants";
import WithAuthorization from "../../../../app/src/Utils/WithAuthorization";
import {
  DEFAULT_COMMENT_LIMIT,
  DEFAULT_COMMENT_SORT,
  DEFAULT_PAGE,
} from "./CommentsConstants";
import i18n from "../../../../app/src/i18n";
import { URL_BASE, URL_BASE_IMAGE } from "../../../../app/src/services/servicesConstants";
import {getToken, getWidgetDescription, getWidgetTitle, getAgeRestrictionLabel} from "../../../../app/src/Utils/utils";
import { usePageSeo } from "../../../../app/src/Utils/usePageSeo";
import { USER_ANONYMOUS } from "../../../../home/src/Pages/Home/HomeComponentConstants";
import { isCordovaAvailable } from "../../../../app/src/Utils/secureStorageUtil";
import Player from "../../../../player/src/Pages/Player/Player";
import ScriptEmbed from "./Widgets/ScriptEmbed";
import { PLAYER_VERSION_LEGACY } from "../../../../app/src/Utils/Constants";

const DetailPage = ({ scrollRef }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  let { id } = useParams();
  const isMobile = isCordovaAvailable();
  const isMobileWidth = window.innerWidth < 480;
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 1200);
  const { keycloak, initialized } = useKeycloak();
  const userToken = getToken(keycloak);
  const { userData: userDetails, userLogin } = useSelector((state) => state.commonState);
  const username = keycloak?.tokenParsed?.preferred_username || userDetails?.username || userLogin;

  const userInformation = useSelector((state) => state.commonState.userData);
  const translations = useSelector((state) => state.commonState.translations);
  const { userURLAvatar, contentHash, contentType, contentPermissions } = useSelector((state) => state.commonState);
  const query = new URLSearchParams(window.location.search);
  const payload = query.get("payload") || false;

  const titleColor = document
    .getElementById("root")
    .style.getPropertyValue("--rowTitleColor");

  const [content, setContent] = useState(null);
  const [serialContents, setSerialContens] = useState([]);
  const [totalComments, setTotalComments] = useState(null);
  const [userAvatar, setUserAvatar] = useState(null);
  const [userData, setUserData] = useState(null);
  const [displayOptions, setDisplayOptions] = useState(null);
  const [sentMessage, setSentMessage] = useState(false);
  const [reason, setReason] = useState(null);
  const [reasonDescription, setReasonDescription] = useState(undefined);
  const [reportSuccess, setReportSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [shareContent, setShareContent] = useState(null);
  const [sessionExpiredModal, setSessionExpiredModal] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [calendarButton, setCalendarButton] = useState(null);
  const [accessBehavior, setAccessBehavior] = useState(null);
  const [urlToRedirect, setUrlToRedirect] = useState(null);
  const [checkoutURL, setCheckoutURL] = useState(null);
  const [allowed, setAllowed] = useState(undefined);
  const [widgetType, setWidgetType] = useState(WIDGET_TYPE_BANNER);
  const [serialWidgetType, setSerialWidgetType] = useState(WIDGET_TYPE_BANNER);
  const [isPayRequired, setIsPayRequired] = useState(false);
  const [isAgeRestricted, setIsAgeRestricted] = useState(false);
  const [hasAgeRestriction, setHasAgeRestriction] = useState(false);
  const [ageRestrictionTag, setAgeRestrictionTag] = useState(null);
  const [allComments, setAllComments] = useState(null);
  const [textMessageErrorBody, setTextMessageErrorBody] = useState(
    "error.modal.rating.message"
  );
  const [playerUrl, setPlayerUrl] = useState(null);
  const [playerHash, setPlayerHash] = useState(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [isPlayerLoading, setIsPlayerLoading] = useState(false);
  const iframeRef = useRef(null);
  const isLoginRequired = MULTITENANT_CONSTANTS[TENANT].showLoginButton;

  const refOptions = useRef(null);
  const refShare = useRef(null);

  const tenantStyles = useSelector((state) => state.commonState.tenantStyles);
  const playerVersion = useSelector((state) => state.commonState.playerVersion);
  // El tenant indica en /interfaz qué player usa: "v1" el antiguo (iframe), "v2" el nuevo (embed.js).
  // Hasta que /interfaz responde no montamos ningún player para no cargar el que no toca.
  const isPlayerVersionResolved = !!playerVersion;
  const isLegacyPlayer = playerVersion === PLAYER_VERSION_LEGACY;
  const isPlayerReady = isLegacyPlayer
    ? isCordovaAvailable() || !!playerUrl
    : isPlayerVersionResolved;

  const seoTitle = getWidgetTitle(content?.content);
  const seoDescription = getWidgetDescription(content?.content) || tenantStyles?.description;

  usePageSeo({
    title: seoTitle,
    description: seoDescription,
    tenantStyles,
  });

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const version = MULTITENANT_CONSTANTS[TENANT].contentDetailsVersion
    ? MULTITENANT_CONSTANTS[TENANT].contentDetailsVersion
    : 2;

  const languageSelected =
    useSelector((state) => state.commonState.languageSelected) || i18n.language;

  const locale = localStorage.getItem(LOCAL_STORAGE_KEY__LOCALE) || i18n.language;

  const loadTenantLocale = () => {
    moment.locale(tenantStyles.momentLocale);
  };

  const getCommentsCallback = (response) => {
    if (!response || !response.comments) {
      setAllComments([]);
      return;
    }
    const sortedComments = response.comments.sort((a, b) => new Date(b.date) - new Date(a.date));
    setAllComments(sortedComments);
  };

  useEffect(() => {
  }, [allComments]);

  useEffect(() => {
    if (!!userURLAvatar) {
      setUserAvatar(userURLAvatar);
    }
  }, [userURLAvatar]);

  useEffect(() => {
    isLoginRequired && MULTITENANT_CONSTANTS[TENANT].showComments &&
      getCommentsService(
        TENANT,
        id,
        DEFAULT_COMMENT_LIMIT,
        DEFAULT_PAGE,
        DEFAULT_COMMENT_SORT,
        userToken,
        getCommentsCallback
      );
    loadTenantLocale();
  }, [id]);

  useEffect(() => {
    !!username && MULTITENANT_CONSTANTS[TENANT].analytics && logUserAnalyticService(
      TENANT,
      username,
      PAGE_VIEW_ACTION,
      PAGE_ID_KEY,
      DETAIL_VALUE,
      userToken
    );
  }, [userData]);

  const handleShareContent = () => {
    setShareContent(!shareContent);
  };

  const hideShareModal = () => {
    setShareContent(false);
  };

  const toggleOptions = () => {
    setDisplayOptions(!displayOptions);
  };

  const reportContentServiceCallback = () => {
    setReportSuccess(true);
    setSentMessage(true);
  };

  useEffect(() => {
    if (reportSuccess === true) {
      setTimeout(() => {
        setReportSuccess(false);
      }, 3000);
    }
  }, [reportSuccess]);

  const handleReportContent = () => {
    reportContentService(TENANT, id, reasonDescription, userToken, reportContentServiceCallback);
    setReason(null);
  };

  const handleCloseModal = () => {
    setReasonDescription(undefined);
    setSentMessage(false);
    setDisplayOptions(false);
  };

  const handleSetReason = (value) => {
    setReason(value);
  };

  const handleSetReasonDescription = (event) => {
    setReasonDescription(event.target.value);
    handleSetReason(!!event.target.value);
  };

  const hideOptions = () => {
    setReason(null);
    setDisplayOptions(false);
  };

  const turnOnLoading = () => {
    dispatch(turnOnLoadingActionCreator());
  };

  const turnOffLoading = () => {
    dispatch(turnOffLoadingActionCreator());
  };

  const getRelatedServiceCallback = (response) => {
    setContent((prev) => ({ ...prev, relatedContent: response["contents-related"]?.data, serialContent: response["contents-items"]?.data }));
    setWidgetType(response["contents-related"]?.widget_type ?? WIDGET_TYPE_BANNER);
    setSerialWidgetType(response["contents-items"]?.widget_type ?? WIDGET_TYPE_BANNER);
  };

  const sortContents = (contents) => {
    const orderedContents = contents.sort((a, b) =>
      a.episode > b.episode ? 1 : b.episode > a.episode ? -1 : 0
    );

    return orderedContents;
  };

  useEffect(() => {
    if (content?.content?.type !== "container" && serialContents?.length > 0) {
      const nextContentId = parseInt(id, 10) + 1;
      const contentFiltered = serialContents.find(
        (item) => item.id === nextContentId
      );
      if (contentFiltered) {
        setContent((prev) => ({ ...prev, nextContent: contentFiltered }));
      }
    }
  }, [serialContents, id, content?.content?.type]);

  const getSerialContentsCallback = (response, allowed) => {
    if (response.data[0].type !== "container") {
      setSerialContens(response.data);
    }
  };

  const getWatchNextCallback = (response) => {
    const orderedContents = sortContents(response.data);
    setSerialContens([...orderedContents]);
  };

  useEffect(() => {
    if (
      serialContents?.length === 0 &&
      content?.content?.parent?.type === "container"
    ) {
      getSerialContentsService(
        TENANT,
        content?.content?.parent.id,
        undefined,
        getWatchNextCallback
      );
    }
  }, [serialContents, content]);

  const contentPermissionsCallback = (response, contentType, id) => {
    dispatch(saveContentPermissionsActionCreator({ response, contentType, id }));
    const allowedResponse = response?.allowed;
    setAllowed(allowedResponse);

    if (allowedResponse !== undefined) {
      if (contentType === "container") {
        getSerialContentsService(TENANT, id, allowedResponse, getSerialContentsCallback);
      } else {
        if (response?.hashRequired) dispatch(saveContentHashActionCreator(response.hash));

        // Si no está permitido, mostramos modal y preparamos redirección
        if (!allowedResponse) {
          setAccessBehavior(redirectUserTo(response));
          setMessageModal(true);
          setIsPlayerLoading(false);
        } else {
          setPlayerHash(response?.hash || null);
        }
      }
    } else {
      // Si no viene allowedResponse
      setAccessBehavior(redirectUserTo(response));
      setMessageModal(true);
      setIsPlayerLoading(false);
    }
    turnOffLoading();
  };

  const getUserFavoritesCallback = (response) => {
    const favoriteContents = response.data;
    let isFavorite = false;

    favoriteContents?.forEach((item) => {
      if (item.id === parseInt(id, 10)) {
        isFavorite = true;
      }
    });

    setContent((prev) => ({ ...prev, isFavorite: isFavorite }));
  };

  const scrollMoving = () => {
    if (scrollRef?.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }

  const getContentsCallback = (response, id) => {
    const responseContent = response.data;
    const contentType = responseContent.type;
    dispatch(saveContentTypeActionCreator(contentType));
    dispatch(saveContentActionCreator({ ...responseContent, id }));
    setHasAgeRestriction(false);
    setAgeRestrictionTag(getAgeRestrictionLabel(responseContent?.rating?.code));
    setContent({
      content: responseContent,
      isFree: false,
      canRate: true,
      canFav: true,
      canReport: true,
    });
    if (!!id && isLoginRequired) {
      getContentPermissions(
        TENANT,
        id,
        userToken,
        contentType,
        (response, type) => { contentPermissionsCallback(response, type, id) }
      );
    } else if (!!id && !isLoginRequired) {
      // Si no requiere login, permitir acceso directo al player
      setAllowed(true);
    }
    getRelatedContentsService(TENANT, id, locale, getRelatedServiceCallback);
    getUserFavorites(TENANT, username, userToken, getUserFavoritesCallback);
    scrollMoving();
  };

  const getAnonContentsCallback = (response, id) => {
    const responseContent = response?.data;
    const contentType = responseContent?.type;
    dispatch(saveContentTypeActionCreator(contentType));
    dispatch(saveContentActionCreator({...responseContent, id}));
    setAgeRestrictionTag(getAgeRestrictionLabel(responseContent?.rating?.code));
    setHasAgeRestriction(false);
    setContent({
      content: responseContent,
      isFree: false,
      canRate: false,
      canFav: false,
    });
    if (!!id && isLoginRequired) {
      getContentPermissions(
        TENANT,
        id,
        undefined,
        contentType,
        (response, type) => { contentPermissionsCallback(response, type, id) }
      );
    } else if (!!id && !isLoginRequired) {
      // Si no requiere login, permitir acceso directo al player
      setAllowed(true);
    }
    getRelatedContentsService(
      TENANT,
      id,
      locale,
      getRelatedServiceCallback
    );
    scrollMoving();
  };

  const redirectUserTo = (response) => {
    let actionToRedirect = REDIRECT_TO_LOGIN;
    setUrlToRedirect(URL_LOGIN);
    setTextMessageErrorBody("error.modal.rating.message");
    const errorBody = JSON.parse(response.error_error.http_body);
    switch (response.error_error.http_status_code) {
      case 401:
        break;
      case 403:
        setUrlToRedirect(URL_PRODUCTS + "/" + id);
        const errorKey = errorBody.error?.key;

        if (errorKey === "age-restriction") {
          setIsAgeRestricted(true);
          setHasAgeRestriction(true);
          setIsPayRequired(false);
          setTextMessageErrorBody("error.modal.age.restriction.message");
          actionToRedirect = SHOW_AGE_RESTRICTION_MODAL;
        } else {
          setIsPayRequired(true);
          setIsAgeRestricted(false);
          setTextMessageErrorBody("");
          dispatch(saveProductsActionCreator(errorBody.error.products));
          setUrlToRedirect(URL_PRODUCTS + "/" + id);
          actionToRedirect = REDIRECT_TO_PRODUCTS;
        }
        break;
      default:
        console.error('Error no manejado:', response.error_error.http_status_code);
    }
    return actionToRedirect;
  }

  useEffect(() => {
    if (!!username) {
      getContentsService(TENANT, id, userToken, payload, (response) => { getContentsCallback(response, id) });
    } else {
      getAnonContentsService(TENANT, id, payload, (response) => { getAnonContentsCallback(response, id) });
    }
  }, [id, languageSelected, username]);


  const productCheckoutCallback = (data) => {
    setCheckoutURL(data.url);
  };

  useEffect(() => {
    if ((!!keycloak.authenticated && !!initialized) || isCordovaAvailable()) {
      const body = { returnUrl: `${window.location.origin}/user` };
      getProductsDashboardService(
        MULTITENANT_CONSTANTS[TENANT].tenantServer,
        username,
        locale,
        userToken,
        body,
        productCheckoutCallback
      );
    }
  }, []);

  const getReportTypesCallback = (response) => {
    const reportTypes = response.data;
    const updatedContent = { ...content, availableReportReasons: reportTypes };
    setContent(updatedContent);
  };

  useEffect(() => {
    //getReportTypesService(TENANT, getReportTypesCallback);
  }, []);

  const getUserDataCallback = (response) => {
    dispatch(saveUserDataActionCreator(response));
    setUserData(response);
  };

  useEffect(() => {
    if (isLoginRequired && !!userInformation?.username) {
      setUserData(userInformation);
    } else if (isLoginRequired && !!username) {
      getUserDataService(
        MULTITENANT_CONSTANTS[TENANT].tenantServer,
        username,
        keycloak.token,
        getUserDataCallback
      );
    }
  }, [userInformation]);

  if (!id) {
    return <Redirect to={URL_HOME} />;
  }

  const selectedVideo = (id) => {
    const username = userData?.username ? userData?.username : USER_ANONYMOUS;
    !!username && MULTITENANT_CONSTANTS[TENANT].analytics && logUserAnalyticService(
      TENANT,
      username,
      SELECT_ITEM_ACTION,
      PAGE_ID_KEY,
      DETAIL_VALUE,
      userToken,
      id
    );
  };

  const handleCloseSessionModal = () => {
    setSessionExpiredModal(false);
  };

  const handleCloseMessageModal = () => {
    setMessageModal(false);
    if (!allowed) {
      const fallbackPath = previousRouteRef.current || URL_HOME;
      history.replace(fallbackPath);
    }
  };

  const handleGoToLogin = () => {
    if (isCordovaAvailable()) {
      history.push(URL_LOGIN);
    } else {
      const currentUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
      localStorage.setItem("redirectAfterLogin", currentUrl);
      setMessageModal(true);
      setTextMessageErrorBody("error.modal.rating.message");
      setUrlToRedirect(URL_LOGIN);
    }
  };

  const getTranslation = (field) => {
    const translation = translations.find(t => t.language === languageSelected);
    return translation ? translation[field] : t(field);
  };

  const extraContent = (content) => {
    return (
      <>
        {(content?.isFree || !content?.isFree) && (
          <div className={"textBlock"}>
            <div className={"textTitle alignLeft"}>
              {t("ficha.tipocontenido")}
            </div>
            {content?.isFree ? (
              <div className={"textInfo"}>
                {t("ficha.opciondecontenidogratis")}
              </div>
            ) : (
              <div className={"textInfo"}>
                {t("ficha.opciondecontenidopago")}
              </div>
            )}
          </div>
        )}
      </>
    );
  };

  const renderCalendarButton = () => {
    const contentTypeCondition =
      content?.content?.type === VIDEO_TYPE_LIVE ||
      content?.content?.type === VIDEO_TYPE_LIVE_TIIVII ||
      content?.content?.type.toLowerCase() === VIDEO_TYPE_TIIVII_LIVE.toLowerCase();
    const contentDate = new Date(content?.content?.starttime || content?.content?.start * 1000);
    const now = new Date();

    const dateCondition = contentDate > now;
    setCalendarButton(!!MULTITENANT_CONSTANTS[TENANT]?.showCalendarButton && !!contentTypeCondition && !!dateCondition);
  };

  useEffect(() => {
    if (!!content) {
      renderCalendarButton();
    }
  }, [content]);

  const AGE_BADGE_CLASSES = {
    [AGE_RESTRICTION_7_PLUS]: "ageBadge--7",
    [AGE_RESTRICTION_12_PLUS]: "ageBadge--12",
    [AGE_RESTRICTION_16_PLUS]: "ageBadge--16",
    [AGE_RESTRICTION_18_PLUS]: "ageBadge--18",
  };

  const detailTitleAndAuthor = () => {

    const badgeCode = hasAgeRestriction ? AGE_RESTRICTION_18_PLUS : ageRestrictionTag;
    const ageBadgeLabel = badgeCode;
    const ageBadgeClass = AGE_BADGE_CLASSES[badgeCode];

    return (
        <div className={`FichaTitle ${version === 2 && "FichaTitleV2"}`}>
          <div className="TitleContainer">
            {getWidgetTitle(content?.content)}
            {ageBadgeLabel && (
              <span className={`AgeBadgeTitle ${ageBadgeClass || ""}`}>
                {ageBadgeLabel}
              </span>
            )}
            {isLargeScreen && (
              <div className="HeaderButtonsContainer">
                 {!!username && detailFavorite()}
                 {detailShare()}
              </div>
            )}
          </div>
          {!isLargeScreen && (
            <div className="HeaderButtonsContainer">
               {!!username && detailFavorite()}
               {detailShare()}
            </div>
          )}
          {MULTITENANT_CONSTANTS[TENANT].showAuthor && (
              <span
                  className={"ContentAuthor"}> {t('reportcontent.author')} {content?.content?.author}
            </span>)}
        </div>
    );
  };

  const detailEmisionDateTime = () => {
    const isLiveContent =
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_EXTERNAL_LIVE.toLowerCase() ||
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_TIIVII_LIVE.toLowerCase() ||
      content?.content?.type?.toLowerCase() === VIDEO_TYPE_EXTERNAL_IFRAME.toLowerCase();

    if (!isLiveContent) {
      return null;
    }

    const startTimestamp = content?.content?.start;
    const finishTimestamp = content?.content?.finish;

    if (!startTimestamp || !finishTimestamp) {
      return null;
    }

    const startDate = typeof startTimestamp === 'number'
      ? new Date(startTimestamp * 1000)
      : new Date(startTimestamp);

    const formattedDateTime = moment(startDate).format("LLLL");

    return (
      <div className="EmisionDateTime">
        <span className="EmisionDateTimeLabel">{t("ficha.emisionDateTime")}: </span>
        <span className="EmisionDateTimeValue">{formattedDateTime}</span>
      </div>
    );
  };

  const detailCategory = () => {
    return (
      content?.content?.category &&
      MULTITENANT_CONSTANTS[TENANT].showCategory && (
        <span className="Xenero">{content?.content?.category?.code}</span>
      )
    );
  };

  const detailPublishDate = () => {
    return (
      content?.content?.publishDate &&
      MULTITENANT_CONSTANTS[TENANT].showPublishDate && (
        <span className="Data">
          {moment(content?.content.publishDate, "YYYY-MM-DD").format("ll")}
        </span>
      )
    );
  };

  const detailSeasons = () => {
    return (
      content?.content?.seasons && (
        <span className="Temporadas">
          {t("ficha.seasons", { seasons: content?.content.seasons })}
        </span>
      )
    );
  };

  const detailRating = () => {
    return (
      content?.content?.rating &&
      MULTITENANT_CONSTANTS[TENANT].showRating && (
        <span className="Idade">
          {t("ficha.rating", { rating: content?.content?.rating?.code })}
        </span>
      )
    );
  };

  const detailBackToSeason = () => {
    return (
      !!content?.content?.parent &&
      MULTITENANT_CONSTANTS[TENANT].showBackToSeason && (
        <span className="button-back">
          <Link
            to={URL_VIDEODETAIL + "/" + content?.content?.parent?.id}
            className=""
          >
            {MULTITENANT_CONSTANTS[TENANT].seasonClassification ?
              t('ficha.backToSeason') :
              t('ficha.back')
            }
          </Link>
        </span>
      )
    );
  };

  const setFavoriteCallback = (isFavorite) => {
    setContent((prev) => ({ ...prev, isFavorite: isFavorite }));
  }

  const detailFavorite = () => {
    return (
      content?.canFav &&
      content.content.type !== "container" && (
        <Favorite
          isFavorite={content?.isFavorite}
          id={id}
          username={username}
          playerDetailVersion={true}
          largeVersion={true}
          version={1}
          token={userToken}
          setFavorite={setFavoriteCallback}
        />
      )
    );
  };

  const detailShare = () => {
    return (
      <div className="Share" onClick={() => handleShareContent()}>
        <ShareIcon />
      </div>
    );
  };

  const detailCalendar = () => {
    return calendarButton && <CalendarButtonComponent detail={content} />;
  };

  const detailTags = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showVideoTags &&
      content?.content?.tags?.length > 0 && (
        <div
          className={`VotesCategoriesContainer ${version === 2 && "VotesCategoriesContainerV2 CategoriesV2"
            }`}
        >
          <VideoType subtitle={content?.content} />
          {content?.content?.tags?.map((t, index) => (
            <VideoTag tag={t} key={t + "-" + index} />
          ))}
        </div>
      )
    );
  };

  const detailScore = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showScore && (
        <div
          className={`VotesCategoriesContainer ${version === 2 && "VotesCategoriesContainerV2"
            }`}
        >
          <Rating
            videoDetailId={content?.content.id}
            username={userData?.username}
            editRating={content?.canRate}
            totalRating={content?.content?.valoration}
            votes={content?.content?.votes}
            id={id}
          />
        </div>
      )
    );
  };

  const detailDescriptionMisc = () => {
    return (
      MULTITENANT_CONSTANTS[TENANT].showVideoDetails && (
        <div
          className={`textDetailContainer ${version === 2 && "textDetailContainerV2"
            }`}
        >
          {MULTITENANT_CONSTANTS[TENANT].showAuthor &&
            content?.content?.author !== null && (
              <div className={"textBlock"}>
                <div className={"textTitle alignLeft"}>{t("ficha.autor")}</div>
                <div className={"textInfo"}>{content?.content?.author}</div>
              </div>
            )}
          {content?.content?.category !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>
                {t("ficha.categoria")}
              </div>
              <div className={"textInfo"}>
                {content?.content?.category?.code}
              </div>
            </div>
          )}
          {content?.content?.subcategory !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>
                {t("ficha.subcategoria")}
              </div>
              <div className={"textInfo"}>
                {content?.content?.subcategory?.code}
              </div>
            </div>
          )}
          {content?.content?.publishDate !== null && (
            <div className={"textBlock"}>
              <div className={"textTitle alignLeft"}>{t("ficha.estreno")}</div>
              <div className={"textInfo"}>
                {moment(content?.content?.publishDate).format("DD-MM-YYYY")}
              </div>
            </div>
          )}
          {TENANT !== TENANT_PETISGO && extraContent(content)}
        </div>
      )
    );
  };

  const detailReport = () => {
    return (
      content?.canReport &&
      MULTITENANT_CONSTANTS[TENANT].showReportContentOption &&
      content?.content?.type !== "container" && (
        <div
          className={`"ReportContentContainer" ${version === 2 && "ReportContentContainerV2"
            }`}
        >
          <div className="ReportContent">
            <div
              className="ReportContentButton"
              onClick={() => toggleOptions()}
            >
              <span className="ReportIcon">
                {t("reportcontent.reportbuttonicon")}
              </span>
              <span className="ReportText">
                {t("reportcontent.reportbutton")}
              </span>
            </div>
          </div>
        </div>
      )
    );
  };

  const detailPlayFav = () => {
    return (
      <div
        className={`PlayFavContainer ${version === 2 && "PlayFavContainerV2"}`}
      >
        {detailCalendar()}
      </div>
    );
  };

  const detailDescriptionTitle = () => {
    return (
      <p
        className={`DescriptionTitle ${version === 2 && "DescriptionTitleV2"}`}
      >
        {t("detail.description")}
      </p>
    );
  };

  const detailDescriptionDetail = () => {
    return (
      <div
        className={`DescriptionDetail ${version === 2 && "DescriptionDetailV2"
          }`}
      >
        {getWidgetDescription(content.content)}
      </div>
    );
  };

  const detailViewV2 = () => {
    return (
      <>
        <div className="FichaOverContainer FichaOverContainerV2">
          <div className="detailsContainer">
            <div className="leftSide">
              {detailTitleAndAuthor()}
              {detailEmisionDateTime()}
              <div className="InfoPrevia InfoPreviaV2">
                {detailPublishDate()}
                {MULTITENANT_CONSTANTS[TENANT].playMarathon || (!MULTITENANT_CONSTANTS[TENANT].playMarathon && !!content?.content?.parentId) && detailSeasons()}
                {detailRating()}
              </div>
              {detailPlayFav()}
            </div>
          </div>
        </div>
      </>
    );
  };

  const detailViewV1 = () => {
    return (
      <div className="FichaOverContainer">
        {detailTitleAndAuthor()}
        {detailEmisionDateTime()}
        {detailScore()}
        {detailPlayFav()}
        <div className={`InfoPrevia InfoPreviaV2`}>
          {detailPublishDate()}
          {MULTITENANT_CONSTANTS[TENANT].playMarathon || (!MULTITENANT_CONSTANTS[TENANT].playMarathon && !!content?.content?.parentId) && detailSeasons()}
          {detailRating()}
        </div>
        {detailReport()}
      </div>
    );
  };

  const descriptionViewV2 = () => {
    return (
      <div className="col">
        <div className="row">{detailDescriptionTitle()}</div>
        <div className="row">{detailDescriptionDetail()}</div>
        <div className="row">{detailDescriptionMisc()}</div>
      </div>
    );
  };

  const descriptionViewV1 = () => {
    return (
      <div className="row">
        <div className="col-md-12 col-lg-6">
          {detailDescriptionTitle()}
          {detailDescriptionDetail()}
        </div>
        <div className="col-md-12 col-lg-5">
          {detailDescriptionMisc()}
        </div>
      </div>
    );
  };

  const ppvModalText = getTranslation("ppv_modal_text") || "";

  const location = useLocation();
  const previousRouteRef = useRef(
    location.state?.from ||
    sessionStorage.getItem("detailPreviousRoute") ||
    URL_HOME
  );

  useEffect(() => {
    if (location.state?.from) {
      previousRouteRef.current = location.state.from;
      sessionStorage.setItem("detailPreviousRoute", location.state.from);
    }
  }, [location.state?.from]);

  useEffect(() => {
    if (!isPlayerVersionResolved || !isLegacyPlayer || !allowed || !id) {
      return;
    }

    let url = `${URL_BASE}player/${TENANT}/${id}?detail=true`;

    const params = new URLSearchParams();
    if (!!userToken) {
      params.append('token', userToken);
    }
    const availableHash = !!playerHash ? playerHash : contentHash;
    if (!!availableHash) {
      params.append('hash', availableHash);
    }

    if (isCordovaAvailable()) {
      url = `${url}&device=android`;
    }

    if (!!params.toString()) {
      url = `${url}&${params.toString()}`;
    }

    setIframeLoaded(false);
    setIsPlayerLoading(true);
    setPlayerUrl(url);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, allowed, playerHash, contentHash, userToken, isLegacyPlayer, isPlayerVersionResolved]);

  useEffect(() => {
    if (!isLegacyPlayer) {
      return;
    }

    const handleMessage = (event) => {
      if (event.data === "Iniciada comunicación") {
        sendAutoplay();
      }
    };
    const sendAutoplay = () => {
      iframeRef.current?.contentWindow.postMessage(
        { type: "allowAudioAutoplay" },
        "*"
      );
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [isLegacyPlayer]);

  return (
    <div className="VideoDetailPage DetailPage" id="detailContainer">
      {error && <AlertNotification />}
      {reportSuccess && (
        <AlertNotification
          type="success"
          showtitle={false}
          text={t("reportcontent.success")}
        />
      )}
      {content !== null && content?.content && (
        <>
          <div className={"principalImage"}>
            {isLegacyPlayer && isPlayerLoading && !isCordovaAvailable() && (
              <div className="spinner">
                <CircularProgress size={50} thickness={4} />
              </div>
            )}
            {allowed && isPlayerReady ? (
              <div
                className="PlayerContainer"
                style={content?.content?.background?.data?.asset_url ? {
                  backgroundImage: `url(${URL_BASE_IMAGE}${content.content.background.data.asset_url})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                } : undefined}
              >
                {!isLegacyPlayer ? (
                  <Player id={id} />
                ) : isCordovaAvailable() ? (
                  <div className="Player">
                    <ScriptEmbed id={id} isDetail={true} />
                  </div>
                ) : (
                  <iframe
                    ref={iframeRef}
                    src={playerUrl}
                    className="PlayerIframe"
                    style={{ opacity: iframeLoaded ? 1 : 0 }}
                    onLoad={() => {
                      setIframeLoaded(true);
                      setIsPlayerLoading(false);
                    }}
                    onError={() => {
                      setIsPlayerLoading(false);
                    }}
                    allow="autoplay; encrypted-media; fullscreen; keyboard *"
                    id="player"
                    title={t("player.iframe.title")}
                    width="100%"
                    height="100%"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowfullscreen="true"
                  />
                )}
              </div>
            ) : (
              !isPlayerLoading && content?.content?.background?.data?.asset_url && (
                <img
                  src={`${URL_BASE_IMAGE}${content.content.background.data.asset_url}`}
                  alt="Cover image"
                  className="FichaImage"
                />
              )
            )}
          </div>
          <div className="contentBelowPlayer">
            {version === 2 ? detailViewV2() : detailViewV1()}
          </div>

          {content?.serialContent && (
            <div className={"playlistContainer serialContent"}>
              <Playlist
                clickCallback={selectedVideo}
                playlist={content?.serialContent}
                typeBanner={serialWidgetType}
                detail={true}
                trigger={WIDGET_ACTION_DETAIL}
                className="FrameworkHome"
                turnOffLoading={turnOffLoading}
                turnOnLoading={turnOnLoading}
                titleColor={titleColor}
                contentId={content?.content.id}
              />
            </div>
          )}
          <div className={"contentContainer"}>
            {version === 2 ? descriptionViewV2() : descriptionViewV1()}
            {content?.content?.participants.length > 0 && (
              <Casting
                className="FichaCasting"
                participants={content?.content?.participants}
              />
            )}
            {isLoginRequired && MULTITENANT_CONSTANTS[TENANT].showComments &&
              allComments !== null && (
                <div className="CommentsContainer">
                  <Comments
                    comments={allComments}
                    videoDetailId={content?.content.id}
                    userName={username}
                    totalComments={totalComments}
                    titulo={t("ficha.doacomment")}
                    placeholder={t("ficha.commentplaceholder")}
                    avatar={userAvatar}
                    token={userToken}
                  />
                </div>
              )}
          </div>

          <div className="FichaInfoRelated">
            {content?.relatedContent && (
              <Playlist
                title={t("ficha.explora")}
                clickCallback={selectedVideo}
                hideSubtitle={true}
                playlist={content?.relatedContent}
                typeBanner={widgetType}
                detail={true}
                className="FrameworkHome"
                turnOffLoading={turnOffLoading}
                turnOnLoading={turnOnLoading}
                trigger={WIDGET_ACTION_DETAIL}
                titleColor={titleColor}
                contentId={content?.content.id}
              />
            )}
          </div>
          {displayOptions && (
            <ReportContentModalComponent
              refOptions={refOptions}
              availableReportReasons={content?.availableReportReasons}
              hideOptions={hideOptions}
              reason={reason}
              handleSetReason={handleSetReason}
              reasonDescription={reasonDescription}
              handleSetReasonDescription={handleSetReasonDescription}
              handleReportContent={handleReportContent}
              handleCloseModal={handleCloseModal}
              sentMessage={sentMessage}
            />
          )}
          {shareContent && (
            <ShareContentModalComponent
              hideShareModal={hideShareModal}
              refShare={refShare}
              title={content?.content?.title}
              description={content?.content?.description}
            />
          )}
        </>
      )}
      {isLoginRequired && !isPayRequired && !isAgeRestricted && messageModal && (
        <ErrorMessageModalComponent
          textTitle="error.modal.common.title"
          textBody={textMessageErrorBody}
          textButton="user.login"
          url={urlToRedirect}
          onClose={handleCloseMessageModal}
        />
      )}
      {isLoginRequired && isPayRequired && !isAgeRestricted && messageModal && (
        <ErrorMessageModalComponent
          textTitle={ppvModalText}
          textBody={textMessageErrorBody}
          textButton="user.payment"
          url={urlToRedirect}
          onClose={handleCloseMessageModal}
        />
      )}
      {isLoginRequired && isAgeRestricted && messageModal && (
        <AgeRestrictionModalComponent
          onClose={() => {
            setMessageModal(false);
            setIsAgeRestricted(false);
            if (!allowed) {
              const fallbackPath = previousRouteRef.current || URL_HOME;
              history.replace(fallbackPath);
            }
          }}
        />
      )}
      {isLoginRequired && sessionExpiredModal && (
        <ExpiredSessionModalComponent
          handleCloseModal={handleCloseSessionModal}
        />
      )}
    </div>
  );
};

export default WithAuthorization(DetailPage);
